import script from "./Minifigurtabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./Minifigurtabel.vue?vue&type=script&setup=true&lang=ts"

export default script